<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">
        {{label}}
        <v-icon
            v-if="help_text && help_text != ''"
            right
            style="pointer-events: auto;"
            v-on:click="onClickShowHelpText()"
        >
            mdi-information-outline
        </v-icon>
    </v-card-title>

    <v-card-text>
        
        <v-form
            v-model="valid"
        >


        <v-row>
            
        <v-col>
            <v-text-field
                :label="label"
                v-model="inner_value"
                autofocus
                :rules="rules"
                :hint="hint"
                @keydown.enter="$event.preventDefault(); onOk();"
                autocomplete="off"
            />
        </v-col>

        <v-col>
            <v-select
                :items="units"
                label="Unit"
                v-model="unit"
            />
        </v-col>

        </v-row>

        </v-form>

    </v-card-text>

    <v-card-actions>
        <v-btn
            v-if="unset_label != null"
            text
            v-on:click="dialog = false; $emit('ok', null);"
        >
            {{unset_label}}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!valid"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
const Time = require('@/js/time.js');

export default {

    props: {
        rules: {
            type: Array,
            default: function () { return []; },
        },

        unset_label: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            label: 'field',
            value: '',
            valid: false,
            hint: null,
            help_text: null,
            inner_value: null,

            units: [
                {'text': 'Seconds', 'value' : 'sec'},
                {'text': 'Minutes', 'value' : 'min'},
                {'text': 'Hours', 'value' : 'hr'},
                {'text': 'Days', 'value' : 'day'}
            ],

            unit: null,
        }
    },

    methods: {
        showDialog(label, value, hint, help_text)
        {
            this.label = label;
            this.value = value;
            this.dialog = true; 
            this.hint = hint;
            this.help_text = help_text;

            let pp = Time.prettyPrintDuration(this.value);

            if ( pp == 'none' ) this.unit = 'none';
            else if ( pp.includes('day') ) this.unit = 'day';
            else if ( pp.includes('hour') ) this.unit = 'hr';
            else if ( pp.includes('min') ) this.unit = 'min';
            else if ( pp.includes('second') ) this.unit = 'sec';
            else this.unit = 'min';

            this.inner_value = 0;

            if ( pp.indexOf(' ') >= 0 )
            {
                this.inner_value = parseInt(pp.substring(0,pp.indexOf(' ')));
            }
        },

        onClickShowHelpText()
        {
            this.$rc.alert('Additional Information', this.help_text);
        },
        
        onOk()
        {
            this.dialog = false;

            let unit_in_ms = 1000;
            if ( this.unit == 'sec' ) unit_in_ms = 1000;
            if ( this.unit == 'min' ) unit_in_ms = 60000;
            if ( this.unit == 'hr' ) unit_in_ms = 60*60000;
            if ( this.unit == 'day' ) unit_in_ms = 24*60*60000;

            this.$emit('ok',this.inner_value * unit_in_ms);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>